import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";

// Source: https://fonts.google.com/icons?icon.query=keyboard&selected=Material+Symbols+Rounded:keyboard_double_arrow_right:FILL@0;wght@300;GRAD@0;opsz@24&icon.size=24&icon.color=%23e3e3e3&icon.style=Rounded
export const KeyboardDoubleArrowRightIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Keyboard Double Arrow Right Icon</title>;
    t1 = <path d="M10.0558 12L5.99801 7.92701C5.85968 7.78851 5.78635 7.61701 5.77801 7.41251C5.76968 7.20801 5.84301 7.02818 5.99801 6.87301C6.14301 6.72818 6.31868 6.65576 6.52501 6.65576C6.73135 6.65576 6.90701 6.72818 7.05201 6.87301L11.5463 11.3673C11.6398 11.4609 11.7058 11.5597 11.7443 11.6635C11.7828 11.7673 11.802 11.8795 11.802 12C11.802 12.1205 11.7828 12.2327 11.7443 12.3365C11.7058 12.4403 11.6398 12.5391 11.5463 12.6328L7.05201 17.127C6.91351 17.2653 6.74201 17.3387 6.53751 17.347C6.33301 17.3553 6.15318 17.282 5.99801 17.127C5.85318 16.982 5.78076 16.8063 5.78076 16.6C5.78076 16.3937 5.85318 16.218 5.99801 16.073L10.0558 12ZM16.4058 12L12.348 7.92701C12.2097 7.78851 12.1363 7.61701 12.128 7.41251C12.1197 7.20801 12.193 7.02818 12.348 6.87301C12.493 6.72818 12.6687 6.65576 12.875 6.65576C13.0813 6.65576 13.257 6.72818 13.402 6.87301L17.896 11.3673C17.9897 11.4609 18.0558 11.5597 18.0943 11.6635C18.1328 11.7673 18.152 11.8795 18.152 12C18.152 12.1205 18.1328 12.2327 18.0943 12.3365C18.0558 12.4403 17.9897 12.5391 17.896 12.6328L13.402 17.127C13.2635 17.2653 13.092 17.3387 12.8875 17.347C12.683 17.3553 12.5032 17.282 12.348 17.127C12.2032 16.982 12.1308 16.8063 12.1308 16.6C12.1308 16.3937 12.2032 16.218 12.348 16.073L16.4058 12Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};